// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"117":"bc99fc54","151":"debd4709","161":"222f9229","209":"e1f55257","478":"57baa464","560":"caf5b40a","745":"b5c83463","922":"f4565e9c","991":"20942d3b"}[chunkId] + ".chunk.js";
};